import { render, staticRenderFns } from "./PrImageResponsive.vue?vue&type=template&id=2820efb8&scoped=true&"
import script from "./PrImageResponsive.vue?vue&type=script&lang=js&"
export * from "./PrImageResponsive.vue?vue&type=script&lang=js&"
import style0 from "./PrImageResponsive.vue?vue&type=style&index=0&id=2820efb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820efb8",
  null
  
)

export default component.exports